import { Injectable } from '@angular/core';
import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';

import { environment } from '../../../environments/environment';
import { StorageService } from '../services';
import { map, mergeMap } from 'rxjs/operators';

@Injectable()
export class UserImpersonationInterceptor implements HttpInterceptor {
  constructor(private storageService: StorageService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler) {
    return this.storageService.get('impersonatedUserId').pipe(
      mergeMap(impersonatedUserId => {
        if (impersonatedUserId) {
          req = req.clone({
            setHeaders: { 'impersonatedUserId': impersonatedUserId }
          });
        }

        return next.handle(req);
      }));
  }
}
